<template>
  <div class="bell no-select">
    <div class="icon" @click="toggleShow">
      <f-awesome :class="{'bell--animated': bells.length > 0}" icon="bell"></f-awesome>
      <div class="count">{{bellsLength}}</div>
    </div>
    <div v-show="showList" class="list">
      <div class="item" v-for="(item, index) in bells" :key="index">
        <div>
          <p v-if="item.type == 'enroll'">{{item.text}}</p>
        </div>
      </div>
      <div v-if="bells.length === 0" class="empty-list">
        Уведомлений нет
      </div>
    </div>
    <div v-show="showList" @click="toggleShow" class="bell--list-back"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Bell",
  data(){
    return {
      showList: false,
      activeFunction: true, // Включение/выключение функционала

      titleCounter: 0,
      titleOldText: 'Enroller - Сервис записи онлайн',
    }
  },
  computed: {
    ...mapState({
      bells: state => state.bell.bells,
      titleInterval: state => state.bell.titleInterval,
    }),
    bellsLength(){
      let result;
      if(this.bells.length > 10){
        result = '10+';
      }else{
        result = this.bells.length;
      }
      return result;
    }
  },
  watch: {
    bells: function(val){
      if(this.titleInterval){
        this.$store.dispatch("removeBellTitleInterval");
        this.setTitle(this.titleOldText);
      }

      if(val.length){
        this.$store.dispatch("addBellTitleInterval", setInterval(() => {
          if(!this.titleCounter){
            this.setTitle('[!!! Уведомление]');
            this.titleCounter = 1;
          }else{
            this.setTitle(this.titleOldText);
            this.titleCounter = 0;
          }
        }, 1000));
      }
    },
    showList: function(val){
      if(val){
        this.$store.dispatch("removeBellTitleInterval");
        this.setTitle(this.titleOldText);
      }
    }
  },
  methods: {
    toggleShow(){
      this.showList = !this.showList;
    },
    setTitle(titleName){
      let the_title = document.querySelector("title");
      the_title.innerHTML = titleName;
    }
  },
};
</script>

<style scoped lang="less">
  @keyframes bell-animate{
    0% {
      transform:rotate(0deg) scale(1);
    }
    25% {
      transform:rotate(20deg) scale(1.1);
    }
    75% {
      transform:rotate(5deg) scale(1.2);
    }
    100% {
      transform:rotate(15deg) scale(1.1);
    }
  }
  .bell--animated{
    animation: bell-animate 1s infinite;
  }

.bell{
  position: relative;
  cursor: pointer;
  width: 20px;
  margin: 0 auto;

  .icon{
    color: #F97979;
    position: relative;
    z-index: 3;
    height: 40px;

    .count{
      color: #fff;
      position: absolute;
      top: -9px;
      right: -4px;
      font-size: 11px;
    }

    svg{
      cursor: pointer;
      font-size: 18px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }
  }
  .list{
    width: 180px;
    padding: 12px;
    max-height: 250px;
    overflow: auto;
    position: absolute;
    top: 35px;
    left: 0;
    background-color: #fff;
    color: #333;
    box-shadow: 0px 5px 89px 0px rgba(0, 0, 0, 0.75);
    box-sizing: border-box;
    z-index: 3;
    border-radius: 4px;

    .item{
      margin-bottom: 12px;
      border-bottom: 1px solid #F97979;
      line-height: 1.3;
      font-size: 13px;
    }
  }
  .bell--list-back{
    width: 100%;
    height: 100%;
    background-color: transparent;
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
  }
}
</style>
